function describeTrend(points: number[]) {
  if (points.length < 2) {
    return "flat"
  }

  const delta = points[points.length - 1]! - points[0]!
  if (delta > 0.5) return "increasing"
  if (delta < -0.5) return "decreasing"
  return "flat"
}

export function TrendSparkline({
  points,
  className = "h-8 w-24",
}: {
  points: number[]
  className?: string
}) {
  if (points.length === 0) {
    return <div className={`${className} rounded bg-slate-100`} />
  }

  const width = 96
  const height = 32
  const min = Math.min(...points)
  const max = Math.max(...points)
  const range = max - min || 1

  const path = points
    .map((point, index) => {
      const x = points.length === 1 ? width / 2 : (index / (points.length - 1)) * width
      const y = height - ((point - min) / range) * (height - 4) - 2
      return `${index === 0 ? "M" : "L"}${x.toFixed(2)},${y.toFixed(2)}`
    })
    .join(" ")

  const trend = describeTrend(points)
  const stroke =
    trend === "increasing" ? "#059669" : trend === "decreasing" ? "#dc2626" : "#64748b"

  return (
    <svg
      aria-label={`Recovery trend: ${trend} over the selected period`}
      className={className}
      role="img"
      viewBox={`0 0 ${width} ${height}`}
    >
      <path d={path} fill="none" stroke={stroke} strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  )
}
